import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Zap } from 'lucide-react';
export function StickyOfferButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 3000; // 3 seconds for slow scroll
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <AnimatePresence data-id="element-220">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed top-2 right-2 z-[100] pointer-events-none" data-id="element-221">
          <button onClick={scrollToPricing} className="pointer-events-auto text-white font-black py-1.5 px-3 rounded-full shadow-[0_4px_15px_rgba(22,223,96,0.4)] hover:shadow-[0_6px_20px_rgba(22,223,96,0.6)] transition-all flex items-center gap-1.5 group active:scale-95 border border-white/20 bg-[#27850D]" data-id="element-222">
            <Zap className="w-3 h-3 fill-white animate-pulse" data-id="element-223" />
            <span className="uppercase tracking-widest text-[9px] md:text-[10px] whitespace-nowrap" data-id="element-224">
              VER OFERTA
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}